import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import {
  Paper, Typography, Icon, Button, withStyles,
} from '@material-ui/core';
import PropTypes from 'prop-types';
import cloneDeep from 'lodash/cloneDeep';
import every from 'lodash/every';
import get from 'lodash/get';
import isEqual from 'lodash/isEqual';
import pickBy from 'lodash/pickBy';
import DisplayResources from '../crud/DisplayResources';
import { commonResourceStyle, v2DropdownStyles } from '../../css/style';
import {
  resourceFields,
  orderPaginationCount,
  deliveryOptionIconName,
  orderStatusColors,
  orderTypes,
  orderFiltersTitles,
  orderFiltersDropdownOptions,
  ordersFilterFields,
} from '../../data/Constants';
import * as types from '../../redux/resource/ResourcesActionTypes';
import CraverBreadCrumb from '../share/CraverBreadCrumb';
import LoadingBar from '../share/LoadingBar';
import SearchComponent from '../share/SearchComponent';
import Filter from '../share/Filter';
import { InlineDateTimePicker } from 'material-ui-pickers';
import moment from 'moment';
import InputBase from '@material-ui/core/InputBase';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import ExpandMore from '@material-ui/icons/ExpandMore';
import withWidth from 'material-ui/utils/withWidth';
import { getOrderFilters } from '../../api/orders/OrderFilterQuery';
const commonStyles = commonResourceStyle();
const dropdownStyles = v2DropdownStyles();

class Orders extends Component {
  constructor(props) {
    super(props);
    const { orders } = this.props;
    const allOrdersHaveItems = Array.isArray(orders) && orders.filter(order => order.items === undefined).length === 0;
    this.state = {
      justOpenedPage: true,
      needFetchItems: !allOrdersHaveItems,
      orders: [],
      orderType: '',
      filteredOrders: [],
      orderStatus: '',
      from: '',
      to: '',
      searchText: '',
      lastUsedFilters: {
        searchText: '',
        orderType: '',
        orderStatus: '',
        from: '',
        to: '',
        locationIds: [],
      },
      isFiltersSameAsLastUsedFilters: true,
      locationIds: [],
      isLocationSearchOpen: false,
    };

    this.getStoredFilters = this.getStoredFilters.bind(this);
    this.filterByStoredFilters = this.filterByStoredFilters.bind(this);
    this.storeFilter = this.storeFilter.bind(this);
    this.getInitialOrders = this.getInitialOrders.bind(this);
  }

  componentDidMount = async () => {
    await this.getOrdersResources();
  }

  componentDidUpdate = async (prevProps) => {
    const { apiToken } = this.props;
    if (prevProps.apiToken !== apiToken) {
      await this.getOrdersResources();
    }
  }

  getOrdersResources = async () => {
    const {
      actions, apiToken, orders, locations,
    } = this.props;

    if (orders) {
      if (orders.filter(order => order.items === undefined).length === 0) {
        await this.setState({ needFetchItems: false });
      }
    }
    actions.getAllResources(apiToken, 'locations');

    if (this.hasOrdersWhenPageOpened()) {
      if (get(this.props, 'location.state.fromOrderItems') || get(this.props, 'location.state.fromCreateAndEditResource')) {
        await this.getInitialOrders();
        this.props.history.location.state.fromOrderItems = false;
        return;
      }
      this.useExistingOrdersAndFilters();
      return;
    }

    const isLoadingPreviousFilters = this.filterByStoredFilters();
    if (isLoadingPreviousFilters) return;

    await this.getInitialOrders();
  }

  hasOrdersWhenPageOpened() {
    const { orders } = this.props;
    const { justOpenedPage } = this.state;
    return Array.isArray(orders) && orders.length > 0 && justOpenedPage;
  }

  useExistingOrdersAndFilters() {
    const { orders } = this.props;
    const storedFilters = this.getStoredFilters();
    const filteredOrders = cloneDeep(orders);
    this.setState({
      ...storedFilters, filteredOrders, justOpenedPage: false,
    });
  }

  async getInitialOrders() {
    const { actions, apiToken } = this.props;
    const queryParams = `orders/v2?start=0&count=${orderPaginationCount}`;
    await actions.getAllResources(apiToken, queryParams).then(async (res) => {
      this.loadOrders(res, 'firstFetch');
    });
  }

  getStoredFilters() {
    const keys = ['searchText', 'orderType', 'orderStatus', 'from', 'to'];
    const values = keys.map((key) => {
      const value = sessionStorage.getItem(key);
      if (['from', 'to'].includes(key)) return value ? moment(value) : null;
      if (['orderStatus', 'orderType'].includes(key)) return this.rehydrateSingleSelectValue(key, value);
      if (key === 'searchText') return value;
    });

    // If there's no filters stored at all
    if (every(values, val => !val)) return;

    const newState = {};
    keys.forEach((key, ind) => {
      const value = values[ind];
      if (!value) return;
      newState[key] = value;
    });

    newState.needFetchItems = false;
    return newState;
  }

  rehydrateSingleSelectValue(key, value) {
    return orderFiltersDropdownOptions[key].find(option => option.value === value);
  }

  filterByStoredFilters() {
    const newState = this.getStoredFilters();
    if (!newState) return;
    this.setState(newState, this.handleSubmitFilters);
    return true;
  }

  storeFilter(stateKey, value) {
    let finalValue;
    if (['from', 'to'].includes(stateKey)) finalValue = value.toISOString();
    // Convert the dropdownOption object in state to just its option value string, e.g. 'DELIVERY'
    if (['orderStatus', 'orderType'].includes(stateKey)) finalValue = get(value, 'value');
    if (stateKey === 'searchText') finalValue = value;

    const isString = typeof finalValue === 'string';
    finalValue = isString ? finalValue : JSON.stringify(finalValue);
    sessionStorage.setItem(stateKey, finalValue);
  }

  onChangeFilterValue = (stateKey, value) => {
    this.storeFilter(stateKey, value);
    this.setState({ [stateKey]: value }, this.updateIsCurrentFiltersSameAsLastUsed);
  }

  handleSearch = (term) => {
    this.storeFilter('searchText', term);
    this.setState({ searchText: term }, this.handleSubmitFilters);
  }

  submitCurrentSearchTextAndFilters = () => {
    const { searchText } = this.state;
    this.storeFilter('searchText', searchText);
    this.handleSubmitFilters();
  }

  isFiltersSameAsLastUsed = (newFilters) => {
    const { lastUsedFilters } = this.state;
    const keys = ['searchText', 'from', 'to', 'orderStatus', 'orderType', 'locationIds'];
    const isChanged = keys.some((key) => {
      const newValue = newFilters[key];
      const prevValue = lastUsedFilters[key];
      if (key === 'orderStatus') {
        // !prevValue && !!newValue catches if you go from the placeholder to a normal option, and judges no change has happened
        // if you went from the placeholder to the placeholder again.
        return (
          (!prevValue && !!newValue)
          || (!!prevValue && !newValue)
          || (!!prevValue && !!newValue && prevValue !== newValue)
        );
      } else if (key === 'locationIds') {
        return !isEqual(newValue, prevValue);
      }

      return newValue !== prevValue;
    });

    return !isChanged;
  }

  handleSubmitFilters = () => {
    const { actions, apiToken } = this.props;
    const queryParams = this.getSubmitFiltersQueryParams('filters');

    const body = this.getCurrentFiltersWithRenamedKey('deliveryOption');
    const newFilters = this.getCurrentFiltersWithRenamedKey('orderType');

    this.setState({ lastUsedFilters: newFilters, isFiltersSameAsLastUsedFilters: true });
    const emptyValuesRemoved = pickBy(body, val => !!val);
    const query = getOrderFilters(queryParams, emptyValuesRemoved);

    // The API search endpoint is a GET request
    actions.getAllResources(apiToken, query).then((res) => {
      this.loadOrders(res, 'filters');
    });
  }

  handleClickViewMore = () => {
    const { actions, apiToken } = this.props;
    const queryParams = this.getSubmitFiltersQueryParams('viewMore');
    const body = this.getLastUsedFiltersForRequest();
    this.revertCurrentFilters();
    const emptyValuesRemoved = pickBy(body, val => !!val);
    const query = getOrderFilters(queryParams, emptyValuesRemoved)

    // The API search endpoint is a GET request
    actions.getAllResources(apiToken, query).then((res) => {
      this.loadOrders(res, 'viewMore');
    });
  }

  loadOrders = async (res, eventSource) => {
    const { actions,orders } = this.props;
    const newState = { filteredOrders: orders };
    if (eventSource === 'viewMore') {
      actions.updateLoadingState(types.VIEW_MORE_RESOURCE_SUCCESS);
    }
    if (eventSource === 'firstFetch') {
      newState.needFetchItems = false;
    }
    this.setState(newState);
  }

  handleClearSearch = () => {
    this.setState({
      searchText: '',
      orderType: '',
      orderStatus: '',
      from: '',
      to: '',
    }, () => {
      this.resetIsFiltersSameAsLastUsed();
      this.getInitialOrders();
    });
  }

  reprintUserOrder(order) {
    const { user, reprintOrder } = this.props;
    reprintOrder(user, order.id);
  }

  resetIsFiltersSameAsLastUsed = () => this.setState({ isFiltersSameAsLastUsedFilters: true });

  updateSearchText = (value) => {
    this.setState({ searchText: value }, this.updateIsCurrentFiltersSameAsLastUsed);
  }

  getSelectedFilterOption = fieldKey => (fieldKey === 'deliveryOption' ? this.state.orderType : this.state[fieldKey])

  renderDateTimePicker = (stateKey) => {
    const style = stateKey === 'from' ? commonStyles.leftDateTimePicker : commonStyles.rightDateTimePicker;
    return (
      <InlineDateTimePicker
        keyboard
        value={this.state[stateKey]}
        onChange={momentObj => this.onChangeFilterValue(stateKey, momentObj)}
        format="YYYY/MM/DD hh:mm A"
        openTo="year"
        style={style}
        mask={[
          /\d/,
          /\d/,
          /\d/,
          /\d/,
          '/',
          /\d/,
          /\d/,
          '/',
          /\d/,
          /\d/,
          ' ',
          /\d/,
          /\d/,
          ':',
          /\d/,
          /\d/,
          ' ',
          /a|p/i,
          'M',
        ]}
      />
    );
  }

  getSubmitFiltersQueryParams(eventSource) {
    const { pagination } = this.props;
    return eventSource === 'viewMore'
      ? `orders/v2?start=${pagination.start + pagination.count}&count=${orderPaginationCount}`
      : `orders/v2?start=0&count=${orderPaginationCount}`;
  }

  getLastUsedFiltersForRequest = () => {
    const { lastUsedFilters } = this.state;
    const { orderType, ...restFilters } = lastUsedFilters;
    return { ...restFilters, deliveryOption: orderType };
  }

  revertCurrentFilters = () => {
    const { lastUsedFilters } = this.state;
    const {
      from,
      to,
      orderStatus,
      orderType,
      ...restLastUsedFilters
    } = lastUsedFilters;
    const { searchText } = lastUsedFilters;

    const momentFrom = from ? moment(from) : '';
    const momentTo = from ? moment(to) : '';
    const orderStatusDropdownOption = this.rehydrateSingleSelectValue('orderStatus', orderStatus);
    const orderTypeDropdownOption = this.rehydrateSingleSelectValue('orderType', orderType);

    this.setState({
      ...restLastUsedFilters,
      from: momentFrom,
      to: momentTo,
      orderStatus: orderStatusDropdownOption,
      orderType: orderTypeDropdownOption,
      isFiltersSameAsLastUsedFilters: true,
      searchText,
    });
  }

  getCurrentFiltersWithRenamedKey(deliveryOptionFinalName) {
    const {
      from,
      to,
      searchText,
      orderStatus,
      locationIds,
      orderType,
    } = this.state;

    const deliveryOption = orderType && orderType.value && orderType.value !== 'ALL' ? orderType.value : '';
    const fromISOString = from && from instanceof moment ? from.toISOString() : '';
    const toISOString = to && to instanceof moment ? to.toISOString() : '';

    const body = {
      searchText,
      orderStatus: orderStatus && orderStatus.value,
      from: fromISOString,
      to: toISOString,
      locationIds,
      [deliveryOptionFinalName]: deliveryOption,
    };
    return body;
  }

  isCurrentFiltersSameAsLastUsed = () => {
    const newFilters = this.getCurrentFiltersWithRenamedKey('orderType');
    const isFiltersSameAsLastUsedFilters = this.isFiltersSameAsLastUsed(newFilters);
    return isFiltersSameAsLastUsedFilters;
  }

  handleCloseLocationMultiSelect = () => {
    const isFiltersSameAsLastUsedFilters = this.isCurrentFiltersSameAsLastUsed();
    this.setState({ isLocationSearchOpen: false, isFiltersSameAsLastUsedFilters });
  }

  updateIsCurrentFiltersSameAsLastUsed = () => {
    const newIsFiltersSameAsLastUsedFilters = this.isCurrentFiltersSameAsLastUsed();
    const { isFiltersSameAsLastUsedFilters } = this.state;
    if (newIsFiltersSameAsLastUsedFilters === isFiltersSameAsLastUsedFilters) return;
    this.setState({ isFiltersSameAsLastUsedFilters: newIsFiltersSameAsLastUsedFilters });
  }

  render() {
    const {
      actions, loading, apiToken, orders, pagination, viewMoreLoading, match, locations, width,
    } = this.props;
    const { resource } = match.params;
    const {
      needFetchItems, searchText, locationIds, isFiltersSameAsLastUsedFilters,
    } = this.state;
    // If new orders are loading, use the previous orders from the state
    let mutableOrders = viewMoreLoading !== 0
      ? cloneDeep(this.state.filteredOrders)
      : cloneDeep(orders);
    if (mutableOrders && !needFetchItems) {
      mutableOrders = mutableOrders.filter(order => order.orderStatus !== 'NEW');
      mutableOrders.map((order) => {
        const {
          desiredTime, user, items, address, location, deliveryOption, orderStatus,
        } = order;
        // handle date
        if (desiredTime) {
          const date = new Date(desiredTime * 1000).toLocaleDateString('en-US', { year: '2-digit', month: '2-digit', day: '2-digit' });
          const time = new Date(desiredTime * 1000).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
          order.desiredTime = [<div key={date}>{date}</div>, <div key={time}>{time}</div>];
        }
        // handle user
        if (user) {
          order.user = get(user, 'name', '');
          let telephone = get(user, 'telephone', '');
          if (typeof telephone === 'number') telephone = telephone.toString();
          order.telephone = !!telephone
            ? `(${telephone.substring(0, 3)}) ${telephone.substring(3, 6)} - ${telephone.substring(6)}`
            : '';
        }
        // handle order items
        if (items && items.length > 0) {
          const itemsDisplayArray = [];
          items.forEach(item => itemsDisplayArray.push(<div key={item.id}>{`${item.quantity} x ${item.productItem.name}`}</div>));
          order.items = itemsDisplayArray;
        }
        // handle address
        if (address) {
          const {
            streetAddress, city, province, postalCode, buzzerNumber, unitNumber,
          } = address;
          const addressDisplayArray = [];
          const unitNumberText = unitNumber ? `${unitNumber} - ` : '';
          const postalCodeText = postalCode ? ` - ${postalCode}` : '';
          const fullAddress = `${streetAddress}, ${city}, ${province}`;
          addressDisplayArray.push(<div key={1}>{unitNumberText + fullAddress + postalCodeText}</div>);
          if (buzzerNumber) {
            const buzzerString = `Buzzer: ${buzzerNumber}`;
            addressDisplayArray.push(<div key={2}>{buzzerString}</div>);
          }
          order.address = addressDisplayArray;
        } else if (location) {
          location.address ? order.address = location.address : '';
        }
        if (deliveryOption) {
          const iconName = deliveryOptionIconName[deliveryOption];
          order.deliveryOption = (
            <div style={{
              display: 'flex', flexDirection: 'column', alignItems: 'center', width: '30px',
            }}
            >
              {iconName && <Icon>{iconName}</Icon>}
              {deliveryOption}
            </div>
          );
        }
        if (orderStatus) {
          if (orderStatus === 'CANCELED') {
            order.blurDisplay = true;
          }
          order.orderStatus = (
            <div style={{
              display: 'flex', flexDirection: 'row', alignItems: 'center', color: orderStatusColors[orderStatus],
            }}
            >
              <Icon style={{ fontSize: '15px', paddingRight: '5px' }}>lens</Icon>
              {orderStatus}
            </div>
          );
        }
      });
    }

    if (mutableOrders) {
      mutableOrders.push({ id: 'viewMore', value: 'VIEW MORE' });
    }
    return (
      ((viewMoreLoading === 0 && loading) || needFetchItems)
        ? <LoadingBar />
        : (
          <div style={commonStyles.container}>
            <div style={commonStyles.resourceHeader}>
              <div style={commonStyles.resourceName}>
                <Typography style={commonStyles.resourceName}>Orders</Typography>
              </div>
              <div style={commonStyles.breadcrumbContainer}>
                <CraverBreadCrumb resource={resource} />
              </div>
            </div>
            <Paper style={commonStyles.abovePaperFilterToolbar}>
              <SearchComponent
                resourceName="orders"
                placeholder="Search Name, Order ID or Phone"
                updateParentState={this.updateSearchText}
                onHandleSearch={this.handleSearch}
                onHandleClearSearch={this.handleClearSearch}
                value={searchText}
              />
              {ordersFilterFields.map(field => (
                <Filter
                  dropdownTitle={orderFiltersTitles[field.key]}
                  dropdownOptions={orderFiltersDropdownOptions[field.key]}
                  selectedOption={this.getSelectedFilterOption(field.key)}
                  updateParentState={this.onChangeFilterValue}
                  actions={actions}
                  apiToken={apiToken}
                  ordersSearchText={searchText}
                  dropdownType={field.key}
                />
              ))}
              <Select
                value={locationIds}
                style={{ ...dropdownStyles.dropdownOuterContainer, width: '150px', marginRight: '20px' }}
                input={<InputBase />}
                displayEmpty
                multiple
                onChange={e => this.setState({ locationIds: e.target.value })}
                IconComponent={ExpandMore}
                onClose={this.handleCloseLocationMultiSelect}
                onOpen={() => this.setState({ isLocationSearchOpen: true })}
                open={this.state.isLocationSearchOpen}
                renderValue={selected => (
                  selected.length === 0
                    ? 'All Locations'
                    : locations.filter(loc => selected.includes(loc.id)).map(loc => loc.name).join(', ')
                )}
              >
                {
                  locations && locations.map(location => (
                    <MenuItem key={location.id} value={location.id}>
                      {location.name}
                    </MenuItem>
                  ))
                }
              </Select>
              <div style={commonStyles.dateTimePickersNoWrapContainer}>
                {this.renderDateTimePicker('from')}
                <div style={commonStyles.dateTimePickerDashInBetween}> - </div>
                {this.renderDateTimePicker('to')}
              </div>
              <div style={commonStyles.applyButtonContainer}>
                <Button
                  onClick={this.submitCurrentSearchTextAndFilters}
                  style={commonStyles.applyFiltersButton}
                >
                  Apply
                </Button>
              </div>
            </Paper>
            <Paper style={commonStyles.ordersTablePaper}>
              <DisplayResources
                handleSearch={this.handleSearch}
                updateSearchTextInParent={this.updateSearchText}
                handleClearSearch={this.handleClearSearch}
                dropdownTitle={orderFiltersTitles}
                dropdownOptions={orderFiltersDropdownOptions}
                selectedOption={this.state.orderType}
                updateParentState={this.onChangeFilterValue}
                actions={actions}
                apiToken={apiToken}
                data={mutableOrders}
                fieldNames={resourceFields.orders}
                resourceName="orders"
                isTablet={width >= 'md'}
                viewOnly={false}
                isSeparateToolbar
                onClickViewMore={this.handleClickViewMore}
                totalResource={pagination && pagination.totalSize}
                viewMoreLoading={viewMoreLoading}
                isFiltersSameAsLastUsedFilters={isFiltersSameAsLastUsedFilters}
                submitFilters={this.submitCurrentSearchTextAndFilters}
              />
            </Paper>
          </div>
        )
    );
  }
}

Orders.propTypes = {
  loading: PropTypes.bool.isRequired,
  orders: PropTypes.arrayOf(PropTypes.object),
  actions: PropTypes.objectOf(PropTypes.any).isRequired,
  apiToken: PropTypes.string.isRequired,
  viewMoreLoading: PropTypes.number.isRequired,
  pagination: PropTypes.objectOf(PropTypes.any),
};

Orders.defaultProps = {
  orders: null,
  pagination: null,
};

const sharedStyles = () => ({
  ...commonResourceStyle,
  ...v2DropdownStyles,
});

export default withWidth()(withStyles(sharedStyles)(withRouter(Orders)));
